// LocationComponent.jsx
import React, { useState } from "react";
import CreatableSelect from "react-select/creatable";
import info from "../Assets/Assest/info.png";

function LocationComponent() {
  const [location, setLocation] = useState([]);

  // Sample data for Indian metro cities
  const locationsList = [
    { value: "Mumbai", label: "Mumbai" }, // Financial hub, Bollywood, IT, Pharmaceuticals
    { value: "Delhi", label: "Delhi" }, // Government, IT, Education, Retail
    { value: "Bangalore", label: "Bangalore" }, // IT, Aerospace, Biotech
    { value: "Hyderabad", label: "Hyderabad" }, // IT, Pharmaceuticals, Biotech
    { value: "Pune", label: "Pune" }, // IT, Education, Manufacturing
    { value: "Chennai", label: "Chennai" }, // Automotive, IT, Manufacturing
    { value: "Gurugram", label: "Gurugram" }, // IT, Finance, Real Estate
    { value: "Noida", label: "Noida" }, // IT, Electronics, Media
    { value: "Ahmedabad", label: "Ahmedabad" }, // Textiles, Chemicals, Pharmaceuticals
    { value: "Kolkata", label: "Kolkata" }, // Jute, Steel, IT
    { value: "Surat", label: "Surat" }, // Textiles, Diamond Processing
    { value: "Jaipur", label: "Jaipur" }, // Handicrafts, Tourism, IT
    { value: "Nagpur", label: "Nagpur" }, // Mining, Power, Agriculture
    { value: "Indore", label: "Indore" }, // Manufacturing, Pharma, IT
    { value: "Vadodara", label: "Vadodara" }, // Petrochemicals, Engineering, Pharmaceuticals
    { value: "Chandigarh", label: "Chandigarh" }, // IT, Public Sector Units
    { value: "Coimbatore", label: "Coimbatore" }, // Textiles, Manufacturing, Engineering
    { value: "Visakhapatnam", label: "Visakhapatnam" }, // Shipping, Petrochemicals, IT
    { value: "Ludhiana", label: "Ludhiana" }, // Textiles, Manufacturing, Bicycles
    { value: "Bhopal", label: "Bhopal" }, // Electronics, Manufacturing, Education
    { value: "Rajkot", label: "Rajkot" }, // Engineering, Jewelry, Textiles
    { value: "Jamshedpur", label: "Jamshedpur" }, // Steel, Manufacturing
    { value: "Lucknow", label: "Lucknow" }, // IT, Manufacturing, Handicrafts
    { value: "Kanpur", label: "Kanpur" }, // Leather, Textiles, Chemicals
    { value: "Aurangabad", label: "Aurangabad" }, // Automotive, Pharmaceuticals
    { value: "Thiruvananthapuram", label: "Thiruvananthapuram" }, // IT, Tourism, Aerospace
    { value: "Goa", label: "Goa" }, // Tourism, Mining, Pharmaceuticals
    { value: "Nashik", label: "Nashik" }, // Wine Production, Agriculture, Manufacturing
    { value: "Mangalore", label: "Mangalore" }, // Petrochemicals, Banking, Tourism
    { value: "Haridwar", label: "Haridwar" }, // Pharmaceuticals, FMCG
    { value: "Salem", label: "Salem" }, // Steel, Textiles
    { value: "Ranchi", label: "Ranchi" }, // Mining, Steel
  ];

  // Function to handle selection change
  const handleLocationChange = (selectedOptions) => {
    setLocation(selectedOptions || []);
  };

  return (
    <div className="mb-4">
      <label className="block text-gray-700 font-bold mb-2">Location</label>
      <CreatableSelect
        isMulti
        options={locationsList}
        value={location}
        onChange={handleLocationChange}
        placeholder="Type a location and select..."
        className="mb-4"
      />

      <div className="flex items-center mt-2 space-x-4">
        <label className="inline-flex items-center">
          <input type="checkbox" className="form-checkbox" />
          <span className="ml-2">
            Include candidates who prefer to relocate to above locations
          </span>
        </label>
      </div>

      {/* Exclude candidates with info icon */}
      <div className="flex items-center justify-between">
        <label className="inline-flex items-center">
          <input type="checkbox" className="form-checkbox" />
          <span className="ml-2">
            Exclude candidates who have mentioned Anywhere in ...
          </span>
        </label>
        {/* Info Icon with tooltip */}
        <div className="relative group">
          <img
            src={info}
            alt="info"
            className="w-5 h-5 text-gray-500 cursor-pointer"
          />
          <div className="absolute hidden group-hover:block bg-gray-700 text-white text-xs rounded py-1 px-2 z-10 -top-8 -right-4">
            You will get candidates who are either currently in OR prefer to
            Relocate.
          </div>
        </div>
      </div>
    </div>

  );
}

export default LocationComponent;
